export enum SageUom {
  'Each' = 'Each',
  'Flat of 3' = 'Flat of 3',
  'Flat of 6' = 'Flat of 6',
  'Flat of 8' = 'Flat of 8',
  'Flat of 10' = 'Flat of 10',
  'Flat of 12' = 'Flat of 12',
  'Flat of 14' = 'Flat of 14',
  'Flat of 16' = 'Flat of 16',
  'Flat of 18' = 'Flat of 18',
  'Flat of 20' = 'Flat of 20',
  'Flat of 32' = 'Flat of 32',
}
